var departamentos = [
   {
		"coddepartamento":"01",
		"departamento":"Amazonas"
   },
   {
		"coddepartamento":"02",
		"departamento":"Ancash"
   },
   {
		"coddepartamento":"03",
		"departamento":"Apurimac"
   },
   {
		"coddepartamento":"04",
		"departamento":"Arequipa"
   },
   {
		"coddepartamento":"05",
		"departamento":"Ayacucho"
   },
   {
		"coddepartamento":"06",
		"departamento":"Cajamarca"
   },
   {
		"coddepartamento":"07",
		"departamento":"Cusco"
   },
   {
		"coddepartamento":"08",
		"departamento":"Huancavelica"
   },
   {
		"coddepartamento":"09",
		"departamento":"Huanuco"
   },
   {
		"coddepartamento":"10",
		"departamento":"Ica"
   },
   {
		"coddepartamento":"11",
		"departamento":"Junín"
   },
   {
		"coddepartamento":"12",
		"departamento":"La Libertad"
   },
   {
		"coddepartamento":"13",
		"departamento":"Lambayeque"
   },
   {
		"coddepartamento":"14",
		"departamento":"Lima"
   },
   {
		"coddepartamento":"15",
		"departamento":"Loreto"
   },
   {
		"coddepartamento":"16",
		"departamento":"Madre De Dios"
   },
   {
		"coddepartamento":"17",
		"departamento":"Moquegua"
   },
   {
		"coddepartamento":"18",
		"departamento":"Pasco"
   },
   {
		"coddepartamento":"19",
		"departamento":"Piura"
   },
   {
		"coddepartamento":"20",
		"departamento":"Puno"
   },
   {
		"coddepartamento":"21",
		"departamento":"San Martin"
   },
   {
		"coddepartamento":"22",
		"departamento":"Tacna"
   },
   {
		"coddepartamento":"23",
		"departamento":"Tumbes"
   },
   {
		"coddepartamento":"24",
		"departamento":"Ucayali"
   }
];

var provincias = [
   {
		"01":[
		 {
			"codprovincia":"0101",
			"provincia":"Bagua"
		 },
		 {
			"codprovincia":"0102",
			"provincia":"Chachapoyas"
		 },
		 {
			"codprovincia":"0103",
			"provincia":"Utcubamba"
		 }
	  ]
   },
   {
		"02":[
		 {
			"codprovincia":"0201",
			"provincia":"Casma"
		 },
		 {
			"codprovincia":"0202",
			"provincia":"Huaraz"
		 },
		 {
			"codprovincia":"0203",
			"provincia":"Huaylas"
		 },
		 {
			"codprovincia":"0204",
			"provincia":"Santa"
		 }
	  ]
   },
   {
		"03":[
		 {
			"codprovincia":"0301",
			"provincia":"Abancay"
		 },
		 {
			"codprovincia":"0302",
			"provincia":"Andahuaylas"
		 }
	  ]
   },
   {
		"04":[
		 {
			"codprovincia":"0401",
			"provincia":"Arequipa"
		 },
		 {
			"codprovincia":"0402",
			"provincia":"Camana"
		 },
		 {
			"codprovincia":"0403",
			"provincia":"Caylloma"
		 },
		 {
			"codprovincia":"0404",
			"provincia":"Islay"
		 }
	  ]
   },
   {
		"05":[
		 {
			"codprovincia":"0501",
			"provincia":"Huamanga"
		 }
	  ]
   },
   {
		"06":[
		 {
			"codprovincia":"0601",
			"provincia":"Cajamarca"
		 },
		 {
			"codprovincia":"0602",
			"provincia":"Chota"
		 },
		 {
			"codprovincia":"0603",
			"provincia":"Cutervo"
		 },
		 {
			"codprovincia":"0604",
			"provincia":"Jaen"
		 }
	  ]
   },
   {
		"07":[
		 {
			"codprovincia":"0701",
			"provincia":"Canchis"
		 },
		 {
			"codprovincia":"0702",
			"provincia":"Cusco"
		 },
		 {
			"codprovincia":"0703",
			"provincia":"La Convencion"
		 },
		 {
			"codprovincia":"0704",
			"provincia":"Urubamba"
		 }
	  ]
   },
   {
		"08":[
		 {
			"codprovincia":"0801",
			"provincia":"Huancavelica"
		 }
	  ]
   },
   {
		"09":[
		 {
			"codprovincia":"0901",
			"provincia":"Huanuco"
		 },
		 {
			"codprovincia":"0902",
			"provincia":"Leoncio Prado"
		 }
	  ]
   },
   {
		"10":[
		 {
			"codprovincia":"1001",
			"provincia":"Chincha"
		 },
		 {
			"codprovincia":"1002",
			"provincia":"Ica"
		 },
		 {
			"codprovincia":"1003",
			"provincia":"Nazca"
		 },
		 {
			"codprovincia":"1004",
			"provincia":"Pisco"
		 }
	  ]
   },
   {
		"11":[
		 {
			"codprovincia":"1101",
			"provincia":"Huancayo"
		 },
		 {
			"codprovincia":"1102",
			"provincia":"Chanchamayo"
		 },
		 {
			"codprovincia":"1103",
			"provincia":"Huancayo"
		 },
		 {
			"codprovincia":"1104",
			"provincia":"Jauja"
		 },
		 {
			"codprovincia":"1105",
			"provincia":"Satipo"
		 },
		 {
			"codprovincia":"1106",
			"provincia":"Tarma"
		 },
		 {
			"codprovincia":"1107",
			"provincia":"Yauli"
		 }
	  ]
   },
   {
		"12":[
		 {
			"codprovincia":"1201",
			"provincia":"Chepen"
		 },
		 {
			"codprovincia":"1202",
			"provincia":"Pacasmayo"
		 },
		 {
			"codprovincia":"1203",
			"provincia":"Sanchez Carrion"
		 },
		 {
			"codprovincia":"1204",
			"provincia":"Trujillo"
		 }
	  ]
   },
   {
		"13":[
		 {
			"codprovincia":"1301",
			"provincia":"Chiclayo"
		 },
		 {
			"codprovincia":"1302",
			"provincia":"Lambayeque"
		 }
	  ]
   },
   {
		"14":[
		 {
			"codprovincia":"1401",
			"provincia":"Barranca"
		 },
		 {
			"codprovincia":"1402",
			"provincia":"Callao"
		 },
		 {
			"codprovincia":"1403",
			"provincia":"Cañete"
		 },
		 {
			"codprovincia":"1404",
			"provincia":"Huaral"
		 },
		 {
			"codprovincia":"1405",
			"provincia":"Huaura"
		 },
		 {
			"codprovincia":"1406",
			"provincia":"Lima"
		 }
	  ]
   },
   {
		"15":[
		 {
			"codprovincia":"1501",
			"provincia":"Alto Amazonas"
		 },
		 {
			"codprovincia":"1502",
			"provincia":"Maynas"
		 }
	  ]
   },
   {
		"16":[
		 {
			"codprovincia":"1601",
			"provincia":"Tambopata"
		 }
	  ]
   },
   {
		"17":[
		 {
			"codprovincia":"1701",
			"provincia":"Ilo"
		 },
		 {
			"codprovincia":"1702",
			"provincia":"Mariscal Nieto"
		 }
	  ]
   },
   {
		"18":[
		 {
			"codprovincia":"1801",
			"provincia":"Oxapampa"
		 },
		 {
			"codprovincia":"1802",
			"provincia":"Pasco"
		 }
	  ]
   },
   {
		"19":[
		 {
			"codprovincia":"1901",
			"provincia":"Paita"
		 },
		 {
			"codprovincia":"1902",
			"provincia":"Piura"
		 },
		 {
			"codprovincia":"1903",
			"provincia":"Sullana"
		 },
		 {
			"codprovincia":"1904",
			"provincia":"Talara"
		 },
		 {
			"codprovincia":"1901",
			"provincia":"Sechura"
		 }
	  ]
   },
   {
		"20":[
		 {
			"codprovincia":"2001",
			"provincia":"Juliaca"
		 },
		 {
			"codprovincia":"2002",
			"provincia":"Puno"
		 },
		 {
			"codprovincia":"2003",
			"provincia":"San Román"
		 }
	  ]
   },
   {
		"21":[
		 {
			"codprovincia":"2101",
			"provincia":"Mariscal Caceres"
		 },
		 {
			"codprovincia":"2102",
			"provincia":"Moyobamba"
		 },
		 {
			"codprovincia":"2103",
			"provincia":"Rioja"
		 },
		 {
			"codprovincia":"2104",
			"provincia":"San Martin"
		 }
	  ]
   },
   {
		"22":[
		 {
			"codprovincia":"2201",
			"provincia":"Jorge Basadre"
		 },
		 {
			"codprovincia":"2202",
			"provincia":"Tacna"
		 }
	  ]
   },
   {
		"23":[
		 {
			"codprovincia":"2301",
			"provincia":"Tumbes"
		 },
		 {
			"codprovincia":"2302",
			"provincia":"Zarumilla"
		 }
	  ]
   },
   {
		"24":[
		 {
			"codprovincia":"2401",
			"provincia":"Coronel Portillo"
		 }
	  ]
   }
];


var distritos = [
   {
		"0101":[
		 {
			"coddistrito":"010101",
			"distrito":"Bagua"
		 }
	  ]
   },
   {
		"0102":[
		 {
			"coddistrito":"010201",
			"distrito":"Chachapoyas"
		 }
	  ]
   },
   {
		"0103":[
		 {
			"coddistrito":"010301",
			"distrito":"Bagua Grande"
		 }
	  ]
   },
   {
		"0201":[
		 {
			"coddistrito":"020101",
			"distrito":"Casma"
		 }
	  ]
   },
   {
		"0202":[
		 {
			"coddistrito":"020201",
			"distrito":"Huaraz"
		 }
	  ]
   },
   {
		"0203":[
		 {
			"coddistrito":"020301",
			"distrito":"Caraz"
		 }
	  ]
   },
   {
		"0204":[
		 {
			"coddistrito":"020401",
			"distrito":"Chimbote"
		 },
		 {
			"coddistrito":"020402",
			"distrito":"Nuevo Chimbote"
		 }
	  ]
   },
   {
		"0301":[
		 {
			"coddistrito":"030101",
			"distrito":"Abancay"
		 }
	  ]
   },
   {
		"0302":[
		 {
			"coddistrito":"030201",
			"distrito":"Andahuaylas"
		 }
	  ]
   },
   {
		"0401":[
		 {
			"coddistrito":"040101",
			"distrito":"Arequipa"
		 },
		 {
			"coddistrito":"040102",
			"distrito":"Bustamante Y Rivero"
		 },
		 {
			"coddistrito":"040103",
			"distrito":"Cayma"
		 },
		 {
			"coddistrito":"040104",
			"distrito":"Cercado"
		 },
		 {
			"coddistrito":"040105",
			"distrito":"Cerro Colorado"
		 },
		 {
			"coddistrito":"040106",
			"distrito":"Jacobo Hunter"
		 },
		 {
			"coddistrito":"040107",
			"distrito":"Mariano Melgar"
		 },
		 {
			"coddistrito":"040108",
			"distrito":"Paucarpata"
		 },
		 {
			"coddistrito":"040109",
			"distrito":"Socabaya"
		 },
		 {
			"coddistrito":"040110",
			"distrito":"Yanahuara"
		 }
	  ]
   },
   {
		"0402":[
		 {
			"coddistrito":"040201",
			"distrito":"Camana"
		 }
	  ]
   },
   {
		"0403":[
		 {
			"coddistrito":"040301",
			"distrito":"Majes"
		 }
	  ]
   },
   {
		"0404":[
		 {
			"coddistrito":"040401",
			"distrito":"Mollendo"
		 }
	  ]
   },
   {
		"0501":[
		 {
			"coddistrito":"050101",
			"distrito":"Ayacucho"
		 }
	  ]
   },
   {
		"0601":[
		 {
			"coddistrito":"060101",
			"distrito":"Cajamarca"
		 }
	  ]
   },
   {
		"0602":[
		 {
			"coddistrito":"060201",
			"distrito":"Chota"
		 }
	  ]
   },
   {
		"0603":[
		 {
			"coddistrito":"060301",
			"distrito":"Cutervo"
		 }
	  ]
   },
   {
		"0604":[
		 {
			"coddistrito":"060401",
			"distrito":"Jaen"
		 }
	  ]
   },
   {
		"0701":[
		 {
			"coddistrito":"070101",
			"distrito":"Sicuani"
		 }
	  ]
   },
   {
		"0702":[
		 {
			"coddistrito":"070201",
			"distrito":"Cusco"
		 },
		 {
			"coddistrito":"070202",
			"distrito":"San Jeronimo"
		 },
		 {
			"coddistrito":"070203",
			"distrito":"Wanchaq"
		 }
	  ]
   },
   {
		"0703":[
		 {
			"coddistrito":"070301",
			"distrito":"Santa Ana"
		 }
	  ]
   },
   {
		"0704":[
		 {
			"coddistrito":"070401",
			"distrito":"Machupicchu"
		 },
		 {
			"coddistrito":"070402",
			"distrito":"Urubamba"
		 }
	  ]
   },
   {
		"0801":[
		 {
			"coddistrito":"080101",
			"distrito":"Huancavelica"
		 }
	  ]
   },
   {
		"0901":[
		 {
			"coddistrito":"090101",
			"distrito":"Huanuco"
		 }
	  ]
   },
   {
		"0902":[
		 {
			"coddistrito":"090201",
			"distrito":"Rupa Rupa"
		 }
	  ]
   },
   {
		"1001":[
		 {
			"coddistrito":"100101",
			"distrito":"Chincha Alta"
		 },
		 {
			"coddistrito":"100102",
			"distrito":"Pueblo Nuevo"
		 }
	  ]
   },
   {
		"1002":[
		 {
			"coddistrito":"100201",
			"distrito":"Ica"
		 },
		 {
			"coddistrito":"100202",
			"distrito":"Parcona"
		 }
	  ]
   },
   {
		"1003":[
		 {
			"coddistrito":"100301",
			"distrito":"Marcona"
		 },
		 {
			"coddistrito":"100302",
			"distrito":"Nazca"
		 }
	  ]
   },
   {
		"1004":[
		 {
			"coddistrito":"100401",
			"distrito":"Pisco"
		 }
	  ]
   },
   {
		"1101":[
		 {
			"coddistrito":"110101",
			"distrito":"Chilca"
		 },
		 {
			"coddistrito":"110102",
			"distrito":"El Tambo"
		 }
	  ]
   },
   {
		"1102":[
		 {
			"coddistrito":"110201",
			"distrito":"Chanchamayo"
		 },
		 {
			"coddistrito":"110202",
			"distrito":"Pichanaki"
		 },
		 {
			"coddistrito":"110203",
			"distrito":"San Ramón"
		 }
	  ]
   },
   {
		"1103":[
		 {
			"coddistrito":"110301",
			"distrito":"El Tambo"
		 },
		 {
			"coddistrito":"110302",
			"distrito":"Huancayo"
		 }
	  ]
   },
   {
		"1104":[
		 {
			"coddistrito":"110401",
			"distrito":"Jauja"
		 }
	  ]
   },
   {
		"1105":[
		 {
			"coddistrito":"110501",
			"distrito":"San Martín De Pangoa"
		 },
		 {
			"coddistrito":"110502",
			"distrito":"Satipo"
		 }
	  ]
   },
   {
		"1106":[
		 {
			"coddistrito":"110601",
			"distrito":"Tarma"
		 }
	  ]
   },
   {
		"1107":[
		 {
			"coddistrito":"110701",
			"distrito":"La Oroya"
		 }
	  ]
   },
   {
		"1201":[
		 {
			"coddistrito":"120101",
			"distrito":"Chepen"
		 }
	  ]
   },
   {
		"1202":[
		 {
			"coddistrito":"120201",
			"distrito":"Pacasmayo"
		 }
	  ]
   },
   {
		"1203":[
		 {
			"coddistrito":"120301",
			"distrito":"Huamachuco"
		 }
	  ]
   },
   {
		"1204":[
		 {
			"coddistrito":"120401",
			"distrito":"El Porvenir"
		 },
		 {
			"coddistrito":"120402",
			"distrito":"La Esperanza"
		 },
		 {
			"coddistrito":"120403",
			"distrito":"Trujillo"
		 },
		 {
			"coddistrito":"120404",
			"distrito":"Victor Larco"
		 }
	  ]
   },
   {
		"1301":[
		 {
			"coddistrito":"130101",
			"distrito":"Chiclayo"
		 },
		 {
			"coddistrito":"130102",
			"distrito":"Jose Leonardo Ortiz"
		 }
	  ]
   },
   {
		"1302":[
		 {
			"coddistrito":"130201",
			"distrito":"Lambayeque"
		 }
	  ]
   },
   {
		"1401":[
		 {
			"coddistrito":"140101",
			"distrito":"Barranca"
		 }
	  ]
   },
   {
		"1402":[
		 {
			"coddistrito":"140201",
			"distrito":"Bellavista"
		 },
		 {
			"coddistrito":"140202",
			"distrito":"Callao"
		 },
		 {
			"coddistrito":"140203",
			"distrito":"La Punta"
		 },
		 {
			"coddistrito":"140204",
			"distrito":"Ventanilla"
		 }
	  ]
   },
   {
		"1403":[
		 {
			"coddistrito":"140301",
			"distrito":"Asia"
		 },
		 {
			"coddistrito":"140302",
			"distrito":"Imperial"
		 },
		 {
			"coddistrito":"140303",
			"distrito":"San Pedro De Mala"
		 },
		 {
			"coddistrito":"140304",
			"distrito":"San Vicente De Cañete"
		 }
	  ]
   },
   {
		"1404":[
		 {
			"coddistrito":"140401",
			"distrito":"Chancay"
		 },
		 {
			"coddistrito":"140402",
			"distrito":"Huaral"
		 }
	  ]
   },
   {
		"1405":[
		 {
			"coddistrito":"140501",
			"distrito":"Huacho"
		 }
	  ]
   },
   {
		"1406":[
		 {
			"coddistrito":"140601",
			"distrito":"Ate"
		 },
		 {
			"coddistrito":"140602",
			"distrito":"Barranco"
		 },
		 {
			"coddistrito":"140603",
			"distrito":"Breña"
		 },
		 {
			"coddistrito":"140605",
			"distrito":"Carabayllo"
		 },
		 {
			"coddistrito":"140607",
			"distrito":"Chaclacayo"
		 },
		 {
			"coddistrito":"140608",
			"distrito":"Chorrillos"
		 },
		 {
			"coddistrito":"140609",
			"distrito":"Comas"
		 },
		 {
			"coddistrito":"140610",
			"distrito":"El Agustino"
		 },
		 {
			"coddistrito":"140611",
			"distrito":"Independencia"
		 },
		 {
			"coddistrito":"140612",
			"distrito":"Jesus Maria"
		 },
		 {
			"coddistrito":"140613",
			"distrito":"La Molina"
		 },
		 {
			"coddistrito":"140615",
			"distrito":"La Victoria"
		 },
		 {
			"coddistrito":"140616",
			"distrito":"Lima"
		 },
		 {
			"coddistrito":"140617",
			"distrito":"Lince"
		 },
		 {
			"coddistrito":"140618",
			"distrito":"Los Olivos"
		 },
		 {
			"coddistrito":"140619",
			"distrito":"Lurigancho"
		 },
		 {
			"coddistrito":"140620",
			"distrito":"Lurin"
		 },
		 {
			"coddistrito":"140621",
			"distrito":"Magdalena del Mar"
		 },
		 {
			"coddistrito":"140623",
			"distrito":"Miraflores"
		 },
		 {
			"coddistrito":"140624",
			"distrito":"Pueblo Libre"
		 },
		 {
			"coddistrito":"140625",
			"distrito":"Puente Piedra"
		 },
		 {
			"coddistrito":"140626",
			"distrito":"Rimac"
		 },
		 {
			"coddistrito":"140627",
			"distrito":"San Borja"
		 },
		 {
			"coddistrito":"140628",
			"distrito":"San Isidro"
		 },
		 {
			"coddistrito":"140629",
			"distrito":"San Juan de Lurigancho"
		 },
		 {
			"coddistrito":"140630",
			"distrito":"San Juan de Miraflores"
		 },
		 {
			"coddistrito":"140631",
			"distrito":"San Luis"
		 },
		 {
			"coddistrito":"140632",
			"distrito":"San Martin de Porres"
		 },
		 {
			"coddistrito":"140633",
			"distrito":"San Miguel"
		 },
		 {
			"coddistrito":"140634",
			"distrito":"Santa Anita"
		 },
		 {
			"coddistrito":"140635",
			"distrito":"Santiago de Surco"
		 },
		 {
			"coddistrito":"140637",
			"distrito":"Surquillo"
		 },
		 {
			"coddistrito":"140638",
			"distrito":"Villa El Salvador"
		 },
		 {
			"coddistrito":"140639",
			"distrito":"Villa Maria del Triunfo"
		 },
	  ]
   },
   {
		"1501":[
		 {
			"coddistrito":"150101",
			"distrito":"Yurimaguas"
		 }
	  ]
   },
   {
		"1502":[
		 {
			"coddistrito":"150201",
			"distrito":"Belen"
		 },
		 {
			"coddistrito":"150202",
			"distrito":"Iquitos"
		 },
		 {
			"coddistrito":"150203",
			"distrito":"Punchana"
		 }
	  ]
   },
   {
		"1601":[
		 {
			"coddistrito":"160101",
			"distrito":"Tambopata"
		 }
	  ]
   },
   {
		"1701":[
		 {
			"coddistrito":"170101",
			"distrito":"Ilo"
		 },
		 {
			"coddistrito":"170102",
			"distrito":"Pacocha"
		 }
	  ]
   },
   {
		"1702":[
		 {
			"coddistrito":"170201",
			"distrito":"Moquegua"
		 },
		 {
			"coddistrito":"170202",
			"distrito":"Torata"
		 }
	  ]
   },
   {
		"1801":[
		 {
			"coddistrito":"180101",
			"distrito":"Oxapampa"
		 }
	  ]
   },
   {
		"1802":[
		 {
			"coddistrito":"180201",
			"distrito":"Chaupimarca"
		 },
		 {
			"coddistrito":"180202",
			"distrito":"Yanacancha"
		 }
	  ]
   },
   {
		"1901":[
		 {
			"coddistrito":"190101",
			"distrito":"Paita"
		 }
	  ]
   },
   {
		"1902":[
		 {
			"coddistrito":"190201",
			"distrito":"Castilla"
		 },
		 {
			"coddistrito":"190202",
			"distrito":"Catacaos"
		 },
		 {
			"coddistrito":"190203",
			"distrito":"Chulucanas"
		 },
		 {
			"coddistrito":"190204",
			"distrito":"Piura"
		 },
		 {
			"coddistrito":"190205",
			"distrito":"Tambogrande"
		 }
	  ]
   },
   {
		"1903":[
		 {
			"coddistrito":"190301",
			"distrito":"Sullana"
		 }
	  ]
   },
   {
		"1904":[
		 {
			"coddistrito":"190401",
			"distrito":"Pariñas"
		 }
	  ]
   },
   {
		"1905":[
		 {
			"coddistrito":"190501",
			"distrito":"Sechura"
		 }
	  ]
   },
   {
		"2001":[
		 {
			"coddistrito":"200101",
			"distrito":"Cercado"
		 }
	  ]
   },
   {
		"2002":[
		 {
			"coddistrito":"200201",
			"distrito":"Puno"
		 }
	  ]
   },
   {
		"2003":[
		 {
			"coddistrito":"200301",
			"distrito":"Juliaca"
		 }
	  ]
   },
   {
		"2101":[
		 {
			"coddistrito":"210101",
			"distrito":"Juanjui"
		 }
	  ]
   },
   {
		"2102":[
		 {
			"coddistrito":"210201",
			"distrito":"Moyobamba"
		 }
	  ]
   },
   {
		"2103":[
		 {
			"coddistrito":"210301",
			"distrito":"Nueva Cajamarca"
		 },
		 {
			"coddistrito":"210302",
			"distrito":"Rioja"
		 }
	  ]
   },
   {
		"2104":[
		 {
			"coddistrito":"210401",
			"distrito":"Tarapoto"
		 }
	  ]
   },
   {
		"2201":[
		 {
			"coddistrito":"220101",
			"distrito":"Ilabaya"
		 }
	  ]
   },
   {
		"2202":[
		 {
			"coddistrito":"220201",
			"distrito":"Cono Sur"
		 },
		 {
			"coddistrito":"220202",
			"distrito":"Tacna"
		 }
	  ]
   },
   {
		"2301":[
		 {
			"coddistrito":"230101",
			"distrito":"Tumbes"
		 }
	  ]
   },
   {
		"2302":[
		 {
			"coddistrito":"230201",
			"distrito":"Aguas Verdes"
		 }
	  ]
   },
   {
		"2401":[
		 {
			"coddistrito":"240101",
			"distrito":"Calleria"
		 },
		 {
			"coddistrito":"240102",
			"distrito":"Yarinacocha"
		 }
	  ]
   }
];